import { useEffect, useState, useRef } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Col, Container, Row } from "../../components";
import { useContextHook } from "../../Context/ContextOPen";
import { iconsList, productList } from "../../Context/Lists";
import { content } from "../../lang/useLang";

const Products = () => {
  const { direction } = useContextHook();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [animatedElements, setAnimatedElements] = useState({
    title: false,
    slider: false,
    items: Array(productList.length).fill(false),
  });

  const productsRef = useRef(null);

  // تتبع ظهور القسم
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 1100) {
        setIsVisible(true);

        setTimeout(
          () => setAnimatedElements((prev) => ({ ...prev, title: true })),
          20
        );
        setTimeout(
          () => setAnimatedElements((prev) => ({ ...prev, slider: true })),
          40
        );

        productList.forEach((_, index) => {
          setTimeout(() => {
            setAnimatedElements((prev) => ({
              ...prev,
              items: prev.items.map((item, i) => (i === index ? true : item)),
            }));
          }, 60 + index * 100);
        });
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const openProductModal = (product) => {
    setSelectedProduct(product);
    setActiveImageIndex(0);
    document.body.style.overflow = "hidden";
  };

  const closeProductModal = () => {
    setSelectedProduct(null);
    document.body.style.overflow = "auto";
  };

  // تأثير الجسيمات المتحركة المحسّن
  useEffect(() => {
    if (!isVisible) return;

    const canvas = document.getElementById("particle-canvas");
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    canvas.width = canvas.parentElement.offsetWidth;
    canvas.height = canvas.parentElement.offsetHeight;

    const particles = [];
    const particleCount = 30;

    for (let i = 0; i < particleCount; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        size: Math.random() * 2 + 1,
        speedX: (Math.random() - 0.5) * 0.3,
        speedY: (Math.random() - 0.5) * 0.3,
        color: `rgba(34, 211, 238, ${Math.random() * 0.2 + 0.1})`,
      });
    }

    function animate() {
      if (!isVisible) return;

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach((particle) => {
        particle.x += particle.speedX;
        particle.y += particle.speedY;

        if (particle.x < 0 || particle.x > canvas.width) particle.speedX *= -1;
        if (particle.y < 0 || particle.y > canvas.height) particle.speedY *= -1;

        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
        ctx.fillStyle = particle.color;
        ctx.fill();

        // توصيل الجسيمات القريبة
        particles.forEach((otherParticle) => {
          const dx = particle.x - otherParticle.x;
          const dy = particle.y - otherParticle.y;
          const distance = Math.sqrt(dx * dx + dy * dy);

          if (distance < 80) {
            ctx.beginPath();
            ctx.strokeStyle = `rgba(34, 211, 238, ${
              0.08 * (1 - distance / 80)
            })`;
            ctx.lineWidth = 0.3;
            ctx.moveTo(particle.x, particle.y);
            ctx.lineTo(otherParticle.x, otherParticle.y);
            ctx.stroke();
          }
        });
      });

      requestAnimationFrame(animate);
    }

    animate();

    const handleResize = () => {
      canvas.width = canvas.parentElement.offsetWidth;
      canvas.height = canvas.parentElement.offsetHeight;
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isVisible]);

  return (
    <div
      ref={productsRef}
      className="min py-5 relative overflow-hidden transition-all duration-1000"
      style={{ direction }}
    >
      {/* تأثيرات الخلفية المحسنة */}
      <div className="absolute inset-0 overflow-hidden">
        <canvas id="particle-canvas" className="absolute inset-0 opacity-60" />

        {/* أشكال هندسية عائمة */}
        <div className="absolute top-20 left-10 w-20 h-20 bg-cyan-500/5 rounded-full animate-float-slow"></div>
        <div
          className="absolute top-40 right-20 w-16 h-16 bg-blue-500/5 rounded-full animate-float-medium"
          style={{ animationDelay: "2s" }}
        ></div>
        <div
          className="absolute bottom-32 left-1/4 w-24 h-24 bg-cyan-500/3 rounded-full animate-float-slow"
          style={{ animationDelay: "4s" }}
        ></div>
        <div
          className="absolute bottom-20 right-32 w-18 h-18 bg-blue-500/4 rounded-full animate-float-medium"
          style={{ animationDelay: "1s" }}
        ></div>

        {/* خطوط متقاطعة */}
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-cyan-500/15 to-transparent animate-scan-horizontal"></div>
        <div
          className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-blue-500/15 to-transparent animate-scan-horizontal"
          style={{ animationDelay: "2s" }}
        ></div>
      </div>

      <br />

      <Container className="relative z-10">
        <Row className="items-center">
          <Col md={12}>
            {/* العنوان مع أنيميشن محسنة */}
            <div
              className={`te mb-5 transition-all duration-1000 ${
                isVisible && animatedElements.title
                  ? "opacity-100 translate-y-0 scale-100"
                  : "opacity-0 translate-y-10 scale-95"
              }`}
            >
              <h1 className="text-4xl max-md:text-4xl font-bold mb-3 logo relative inline-block">
                <span
                  className="relative z-10"
                  style={{
                    background:
                      "linear-gradient(135deg, #22d3ee 0%, #3b82f6 50%, #6366f1 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    textShadow: "0 0 30px rgba(34, 211, 238, 0.5)",
                  }}
                >
                  {content.products}
                </span>
                <div className="absolute -inset-4 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-1000"></div>
              </h1>

              <div
                className={`w-32 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full mb-4 shadow-lg shadow-cyan-500/30 transition-all duration-1000 delay-200 ${
                  isVisible && animatedElements.title
                    ? "opacity-100 translate-x-0 scale-x-100"
                    : "opacity-0 translate-x-10 scale-x-0"
                }`}
              ></div>
            </div>

            {/* سلايدر المنتجات */}
            <div
              className={`transition-all duration-1000 ${
                isVisible && animatedElements.slider
                  ? "opacity-100"
                  : "opacity-0"
              }`}
            >
              <Row className="py-5 relative">
                {productList.map((product, index) => (
                  <Col
                    xs={12}
                    sm={6}
                    lg={4}
                    xl={3}
                    key={product.id}
                    className="mb-6"
                  >
                    <div
                      onClick={() => openProductModal(product)}
                      className={`group relative bg-gradient-to-br from-white/10 to-white/5 rounded-3xl overflow-hidden shadow-2xl hover:shadow-cyan-500/20 border border-white/10 backdrop-blur-xl transform transition-all duration-700 hover:scale-[1.02] ${
                        animatedElements.items[index]
                          ? "opacity-100 translate-y-0 scale-100"
                          : "opacity-0 translate-y-8 scale-95"
                      }`}
                      style={{
                        transitionDelay: `${index * 100}ms`,
                        background:
                          "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)",
                        height: "100%", // تأكد من ملء الارتفاع بشكل متساوي
                      }}
                    >
                      {/* تأثير إشعاعي */}
                      <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 via-transparent to-blue-500/5 opacity-0 group-hover:opacity-100 transition-all duration-700"></div>

                      {/* تأثير حدود متحركة */}
                      <div className="absolute -inset-0.5 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-3xl opacity-0 group-hover:opacity-30 blur transition-all duration-500"></div>

                      {/* صورة المنتج - محسنة للموبايل */}
                      <div className="relative overflow-hidden h-48 sm:h-56 md:h-64">
                        <img
                          src={product.image}
                          alt={product.title}
                          className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-110"
                        />

                        {/* طبقة تدرج مع أنيميشن */}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-70 group-hover:opacity-40 transition-all duration-500"></div>

                        {/* تأثير ضوئي */}
                        <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 to-blue-500/10 opacity-0 group-hover:opacity-100 transition-all duration-700"></div>

                        {/* أيقونة العرض السريع */}
                        <button
                          onClick={() => openProductModal(product)}
                          className="absolute top-3 right-3 sm:top-4 sm:right-4 bg-black/50 hover:bg-cyan-600 text-white p-2 sm:p-3 rounded-full shadow-2xl transform translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 hover:scale-110 hover:rotate-12 backdrop-blur-sm"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-4 h-4 sm:w-5 sm:h-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            />
                          </svg>
                        </button>
                      </div>

                      {/* تفاصيل المنتج - محسنة للموبايل */}
                      <div className="p-4 sm:p-6 flex flex-col gap-3 sm:gap-4 relative z-10">
                        {/* العنوان */}
                        <h3 className="text-lg sm:text-xl font-bold text-white group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-cyan-300 group-hover:to-blue-300 transition-all duration-500 text-center line-clamp-2 min-h-[3.5rem] flex items-center justify-center">
                          {content["products_" + product.id]}
                        </h3>

                        {/* الأيقونات - محسنة للموبايل */}
                        <div className="flex justify-center gap-1 sm:gap-2 flex-wrap">
                          {product.icons?.slice(0, 2).map((icon, iconIndex) => (
                            <div
                              key={iconIndex}
                              className="relative group/icon"
                            >
                              <div className="w-8 h-8 sm:w-10 sm:h-10 bg-white/10 rounded-lg sm:rounded-xl flex items-center justify-center backdrop-blur-sm border border-white/20 group-hover/icon:bg-cyan-500/20 transition-all duration-300 hover:scale-110 hover:rotate-12">
                                <img
                                  src={iconsList?.["icon_" + icon]}
                                  alt=""
                                  className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 filter brightness-0 invert"
                                />
                              </div>
                              <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 bg-black/80 text-white text-xs px-2 py-1 rounded opacity-0 group-hover/icon:opacity-100 transition-all duration-300 whitespace-nowrap z-20">
                                {
                                  content?.[
                                    "title_icon_" +
                                      product?.title_icons?.[iconIndex]
                                  ]
                                }
                              </div>
                            </div>
                          ))}
                          {product.icons && product.icons.length > 2 && (
                            <div className="relative group/icon">
                              <div className="w-8 h-8 sm:w-10 sm:h-10 bg-white/10 rounded-lg sm:rounded-xl flex items-center justify-center backdrop-blur-sm border border-white/20 group-hover/icon:bg-cyan-500/20 transition-all duration-300">
                                <span className="text-white text-xs sm:text-sm font-bold">
                                  +{product.icons.length - 2}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* زر التفاصيل - محسن للموبايل */}
                        <button
                          onClick={() => openProductModal(product)}
                          className="bg-gradient-to-r from-cyan-500/20 to-blue-500/20 text-cyan-100 border border-cyan-500/30 text-xs sm:text-sm px-4 sm:px-6 py-2 sm:py-3 rounded-lg sm:rounded-xl hover:shadow-lg transform hover:scale-105 transition-all duration-300 flex items-center justify-center gap-2 group/btn mt-1 sm:mt-2 backdrop-blur-sm hover:bg-cyan-500/30 w-full"
                        >
                          <span>{content["more"]}</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-3 h-3 sm:w-4 sm:h-4 transform group-hover/btn:translate-x-1 transition-transform duration-300"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 5l7 7-7 7"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>
      </Container>

      {/* مودال تفاصيل المنتج - تصميم مدمج */}
      {selectedProduct?.id && (
        <div className="fixed inset-0  bg-black/80  backdrop-blur-xl z-50 flex items-center justify-center p-4 animate-fadeIn">
          <div className="bg-gradient-to-br overflow-scroll from-slate-900 via-blue-900 to-cyan-900 rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] animate-scaleIn border border-cyan-500/20 relative">
            {/* تأثير خلفية المودال */}
            <div className="absolute inset-0 overflow-hidden">
              <div className="absolute -top-10 -right-10 w-20 h-20 bg-cyan-500/10 rounded-full blur-xl"></div>
              <div className="absolute -bottom-10 -left-10 w-20 h-20 bg-blue-500/10 rounded-full blur-xl"></div>
            </div>

            <div className="relative z-10 h-full  flex flex-col">
              {/* الهيدر مع زر الإغلاق وزر PDF */}
              <div className="flex justify-between items-center p-4 border-b border-white/10">
                <h2 className="text-xl font-bold text-white text-center flex-1">
                  {content["products_" + selectedProduct.id]}
                </h2>

                <div className="flex items-center gap-2">
                  <button
                    onClick={closeProductModal}
                    className="bg-black/50 hover:bg-cyan-600 text-white p-2 rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:rotate-90 backdrop-blur-sm border border-white/20"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              {/* المحتوى الرئيسي */}
              <div className="flex-1 overflow-y-auto">
                <div className="grid md:grid-cols-2 gap-6 p-6">
                  {/* قسم الصور */}
                  <div className="space-y-4">
                    {/* الصورة الرئيسية */}
                    <div className="relative bg-gradient-to-br from-cyan-900/50 to-blue-900/50 rounded-xl overflow-hidden h-48">
                      <img
                        src={
                          selectedProduct.images?.[activeImageIndex]?.image ||
                          selectedProduct.image
                        }
                        alt={selectedProduct.title}
                        className="w-full h-full object-cover"
                      />
                    </div>

                    {/* معرض الصور المصغرة */}
                    {selectedProduct.images &&
                      selectedProduct.images.length > 1 && (
                        <div className="flex gap-2 justify-center overflow-x-auto pb-2">
                          {selectedProduct.images.map((img, index) => (
                            <button
                              key={index}
                              onClick={() => setActiveImageIndex(index)}
                              className={`flex-shrink-0 w-12 h-12 rounded-lg overflow-hidden border-2 transition-all duration-300 backdrop-blur-sm ${
                                activeImageIndex === index
                                  ? "border-cyan-400 shadow shadow-cyan-400/30 scale-110"
                                  : "border-white/20 hover:border-cyan-300"
                              }`}
                            >
                              <img
                                src={img.image}
                                alt={`${selectedProduct.title} ${index + 1}`}
                                className="w-full h-full object-cover"
                              />
                            </button>
                          ))}
                        </div>
                      )}
                  </div>

                  {/* قسم التفاصيل */}
                  <div className="space-y-6">
                    {/* الأيقونات */}
                    <div>
                      <h3 className="text-base font-semibold text-cyan-300 mb-3">
                        {content["feature_description1"]}
                      </h3>
                      <div className="grid grid-cols-3 gap-2">
                        {selectedProduct.icons
                          ?.slice(0, 6)
                          .map((icon, index) => (
                            <div
                              key={index}
                              className="flex flex-col items-center justify-center p-2 bg-white/5 rounded-lg border border-white/10 hover:border-cyan-400/30 transition-all duration-300 hover:transform hover:scale-105 hover:-translate-y-1 backdrop-blur-sm group/feature"
                            >
                              <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 rounded-lg flex items-center justify-center mb-1 group-hover/feature:from-cyan-500/30 group-hover/feature:to-blue-500/30 transition-all duration-300">
                                <img
                                  src={iconsList?.["icon_" + icon]}
                                  alt=""
                                  className="w-4 h-4 filter brightness-0 invert"
                                />
                              </div>
                              <div className="text-cyan-100 text-xs font-medium text-center leading-tight">
                                {
                                  content?.[
                                    "title_icon_" +
                                      selectedProduct?.title_icons?.[index]
                                  ]
                                }
                              </div>
                            </div>
                          ))}
                      </div>
                      {selectedProduct.icons &&
                        selectedProduct.icons.length > 6 && (
                          <div className="text-center mt-2">
                            <span className="text-cyan-300 text-sm">
                              +{selectedProduct.icons.length - 6} ميزات إضافية
                            </span>
                          </div>
                        )}
                    </div>

                    {/* المواصفات */}
                    <div>
                      <h3 className="text-base font-semibold text-cyan-300 mb-3">
                        {content["feature_description"]}
                      </h3>
                      <ul className="space-y-2  pr-2">
                        {selectedProduct.descs?.map((desc, index) => (
                          <li
                            key={index}
                            className="flex items-start gap-2 text-cyan-100/90 text-sm animate-fadeInUp"
                            style={{ animationDelay: `${index * 50}ms` }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-4 h-4 text-cyan-400 flex-shrink-0 mt-0.5"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>
                            <span className=" flex-1 leading-relaxed">
                              {content?.["des_products_" + desc] || desc}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* الفوتر */}
              <div className="p-4 border-t border-white/10">
                <div className="flex gap-3">
                  <button
                    onClick={closeProductModal}
                    className="flex-1 bg-gradient-to-r from-cyan-500 to-blue-500 text-white py-3 rounded-xl font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-300 shadow-lg shadow-cyan-500/25 text-sm"
                  >
                    {content["back"]}
                  </button>
                  {/* <button
                    onClick={() => {
                      // دالة تحميل PDF بديلة
                      const pdfUrl = `/pdf/product-${selectedProduct.id}.pdf`;
                      window.open(pdfUrl, "_blank");
                    }}
                    className="flex-1 bg-gradient-to-r from-emerald-500 to-green-600 text-white py-3 rounded-xl font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-300 shadow-lg shadow-emerald-500/25 text-sm flex items-center justify-center gap-2"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-4 h-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                    عرض PDF
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* الأنيميشن المخصصة */}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.8) translateY(20px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes float-slow {
          0%,
          100% {
            transform: translateY(0px) rotate(0deg);
          }
          33% {
            transform: translateY(-15px) rotate(120deg);
          }
          66% {
            transform: translateY(8px) rotate(240deg);
          }
        }
        @keyframes float-medium {
          0%,
          100% {
            transform: translateY(0px) rotate(0deg);
          }
          33% {
            transform: translateY(-12px) rotate(-120deg);
          }
          66% {
            transform: translateY(6px) rotate(-240deg);
          }
        }
        @keyframes scan-horizontal {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.5s ease-out;
        }
        .animate-scaleIn {
          animation: scaleIn 0.6s ease-out;
        }
        .animate-fadeInUp {
          animation: fadeInUp 0.6s ease-out forwards;
          opacity: 0;
        }
        .animate-float-slow {
          animation: float-slow 8s ease-in-out infinite;
        }
        .animate-float-medium {
          animation: float-medium 6s ease-in-out infinite;
        }
        .animate-scan-horizontal {
          animation: scan-horizontal 4s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default Products;
